<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-swap`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_f0a1dfdc67__clip0_1:80)"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 14.827v2a1 1 0 00.883.994l.117.006h36.5c1.756 0 2.637-2.084 1.483-3.343l-.107-.108L33.65 4.688a1 1 0 00-1.322-.048l-.092.086-1.376 1.452a1 1 0 00-.047 1.322l.086.092 6.582 6.235H6a1 1 0 00-.993.884L5 14.827v2-2zM42 30H5.5c-1.756 0-2.637 2.084-1.483 3.343l.108.109L14.35 43.14a1 1 0 001.321.047l.092-.086 1.376-1.451a1 1 0 00.047-1.322l-.086-.092L10.52 34H42a1 1 0 00.993-.883L43 33v-2a1 1 0 00-.883-.993L42 30H5.5 42z"/></g><defs><clipPath id="svg_f0a1dfdc67__clip0_1:80"><path d="M0 0h48v48H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconSwap',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
